import styled from '@emotion/styled'
import React, {forwardRef,} from 'react'
import makeFieldColorPalette from '../../styles/helpers/makeFieldColorPalette'
import ui from '../../styles/ui'
import StyledError from '../StyledError'

const Input = styled('input')(
  ({disabled}) => ({
    ...ui.fieldBaseStyles,
    ...ui.fieldSizeStyles.medium,
    ...makeFieldColorPalette('white', !disabled)
  }),
  ({disabled}) => disabled && {...ui.fieldDisabled}
)

const Error = styled(StyledError)({
  fontSize: 13,
  textAlign: 'left',
  width: '100%'
})


















const BasicInput = forwardRef((props, ref) => {
  const {
    autoComplete,
    autoFocus,
    className,
    disabled,
    error,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    spellCheck,
    type = 'text',
    value,
    readOnly
  } = props
  return (
    React.createElement(React.Fragment, null
      , React.createElement(Input, {
        readOnly: readOnly,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: className,
        disabled: Boolean(disabled),
        ref: ref,
        name: name,
        placeholder: placeholder,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        spellCheck: spellCheck,
        type: type,
        value: value,}
      )
      , error && React.createElement(Error, null, error)
    )
  )
})

export default BasicInput
